import { GridService } from '../shared/grid/grid.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AgentGroup, AgentGroupRecordHistory } from '../models/agentGroup.model';
import { GridModel } from '../shared/grid/grid.model';
import { Observable } from 'rxjs';
import { ColumnDetails } from '../models/columnDetails.model';

@Injectable({
    providedIn: 'root'
})
export class AgentGroupService extends GridService<AgentGroup> {

    constructor(http: HttpClient) {
        super('AgentGroup', http);
    }

    getHistory(params: HttpParams): Observable<GridModel<AgentGroupRecordHistory>> {
        return this.http.get<GridModel<AgentGroupRecordHistory>>(this.getApiUrl(`${this.controllerName}/GetHistory`), {
            params: params
        });
    }

    getHistoryFieldConfiguration(): Observable<{ [property: string]: ColumnDetails }> {
        return this.http.get<{ [property: string]: ColumnDetails }>(
            this.getApiUrl(`${this.controllerName}/GetHistoryFieldConfiguration`)
        );
    }

    getDeletedList(filter: string, orderBy: string, sort: string, page: number, pageSize: number): Observable<GridModel<AgentGroup>> {
        return this.http.get<GridModel<AgentGroup>>(this.getApiUrl(`${this.controllerName}/GetDeletedList`), {
            params: this.createParamsWithFilterBy(filter, orderBy, sort, page, pageSize, '{}'),
        });
    }

    restore(id: string): Observable<void> {
        return this.http.post<void>(this.getApiUrl(`${this.controllerName}/Restore/${id}`), {});
    }
}
